<template>
  <van-empty
    image="error"
    description=""
  />
  <div>
    系统维护中<br />
    维护时间：2026-01-08 01:00~03:00<br />
  </div>
</template>

<script>
import { Empty } from "vant";
export default {
  name: "Emptyview",
  components: {
    [Empty.name]: Empty
  }
};
</script>

<style lang="scss" scoped></style>
